"use strict";

var auth0 = require('auth0-js');
var get = require('lodash.get');
var _require = require('es6-promisify'),
  promisify = _require.promisify;
var makeAuth0Client = function makeAuth0Client(_ref) {
  var domain = _ref.domain,
    clientID = _ref.clientID,
    audience = _ref.audience,
    redirectUri = _ref.redirectUri;
  var webAuth = new auth0.WebAuth({
    domain: domain,
    clientID: clientID,
    audience: audience,
    // for RS256,
    responseType: 'code token id_token',
    redirectUri: redirectUri
  });
  var checkSession = get(webAuth, 'checkSession', function () {});
  var signup = get(webAuth, 'signup', function () {});
  var login = get(webAuth, 'login', function () {});
  var authorize = get(webAuth, 'authorize', function () {});
  var parseHash = get(webAuth, 'parseHash', function () {});
  var logout = get(webAuth, 'logout', function () {});
  return {
    checkSessionAsync: promisify(checkSession.bind(webAuth)),
    signupAsync: promisify(signup.bind(webAuth)),
    loginAsync: promisify(login.bind(webAuth)),
    authorizeAsync: promisify(authorize.bind(webAuth)),
    parseHashAsync: promisify(parseHash.bind(webAuth)),
    logoutAsync: promisify(logout.bind(webAuth))
  };
};
module.exports = {
  makeAuth0Client: makeAuth0Client
};